import { TabContainer as Tab } from './TabContainer'
import { TabContent } from './TabContent'
import { TabPane } from './TabPane'
import { TabLink } from './TabLink'

Tab.Content = TabContent
Tab.Pane = TabPane
Tab.Link = TabLink

export default Tab;